import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import {
    $http,
    MAP_LIST
} from '$http';
// 新增 编辑
export default {
    mixins: [services],
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            title: '',
            modalTypes: MAP_LIST.PROGRESS_TYPE,
            isAddBtnShow: [true],
            isDelBtnShow: [false],
            form: this.getFormData()
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "ModuleId": '',
                "OptionTitle": "",
                "List": [{
                    "Name": ""
                }]
            })
        },
        show(opts) {
            this.form = this.getFormData()
            this.AddDialogVisible = true
            this.title = opts.title
            this.isAddBtnShow = [true]
            this.isDelBtnShow = [false]
            if (opts.isEdit) {
                // 编辑入口
                this.form.Id = opts.Id

                this.GetById(opts.Id)
            }

        },
        removeList(index) {
            if (index !== -1) {
                this.form.List.splice(index, 1)
                this.isAddBtnShow.shift(false)
                this.isDelBtnShow.pop(true)
            }
        },
        addList() {
            this.form.List.push({
                "Name": ""
            });
            this.isDelBtnShow.push(true); //删除按钮
            this.isAddBtnShow.unshift(false); //新增按钮
        },
        // 提交
        submit() {
            // 判断
            if (this.form.ModuleId == '') {
                this.$notify({
                    title: '警告',
                    message: '请选择进度所属模块',
                    type: 'warning'
                });
                return;
            }
            if (this.form.OptionTitle == '') {
                this.$notify({
                    title: '警告',
                    message: '请填写新增的进度选项名',
                    type: 'warning'
                });
                return;
            }
            let len = this.form.List.length
            for (let i = 0; i < len; i++) {
                if (this.form.List[i].Name == '') {
                    this.$notify({
                        title: '警告',
                        message: '请补充填写可选选项内容',
                        type: 'warning'
                    });
                    return;
                }
            }
            if (this.form.Id) {
                // 修改
                this.ModifyOption()
            } else {
                // 新增
                this.AddOption()
            }


        },
        //取消
        close() {
            this.AddDialogVisible = false
            this.isAddBtnShow = [true];
            this.isDelBtnShow = [false];
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/Network/checkList/modalDialog/vm.js